<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Yeni Mail Gönder</h4>
              <p class="card-category">Daha önce oluşturduğunuz maili, bir grup müşterinize veya bir müşterinize
                gönderin.</p>
            </template>

            <form class="m-3">

              <div class="form-group col-md-4">
                <label for="fromMailId">Hangi Mail Adresinden?</label>
                <select id="fromMailId" class="form-control" v-model="payload.fromMailId">
                  <option selected value="-1">Gönderen Mail Adresi Seçiniz.</option>
                  <option v-for="el of fromMails" :value="el._id">{{ el.mail }}</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label for="mailTemplateId">Taslak</label>
                <select id="mailTemplateId" class="form-control" v-model="payload.mailTemplateId">
                  <option selected value="-1">Taslak Seçiniz</option>
                  <option v-for="el of mailTemplates" :value="el._id">{{ el.title }}</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label for="mailTemplateId">Kuyruk İsmi</label>
                <base-input type="text" placeholder="Bir kuyruk ismi giriniz" v-model="payload.queueTitle">
                </base-input>
              </div>

              <div class="form-group col-md-4">
                <label for="mailGroup">Mail Grubu</label>
                <select id="mailGroup" class="form-control" v-model="payload.mailGroupId">
                  <option selected value="-1">Grup Seçiniz</option>
                  <option v-for="el of mailGroups" :value="el._id">{{ el.title }} ({{ el.countRecord }})</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label for="receiversSelect">Alıcı Sınıflandırma</label>
                <select id="receiversSelect" class="form-control" v-model="payload.receiversSelect">
                  <option selected value="-1">Seçim yapınız</option>
                  <option selected value="all">Gruptaki herkese gitsin</option>
                  <option selected value="notSended">Daha önce gönderilmeyenlere gitsin ( Yeni eklenen kullanıcılar )
                  </option>
                </select>
              </div>



              <button @click="submit()" class="btn btn-primary">Kuyruğa Ekle.</button>
            </form>

          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../services/collection.service.js";
export default {
  components: {
    Card
  },
  data() {
    return {
      fromMails: [],
      mailGroups: [],
      mailTemplates: [],
      payload: {
        "plannedSendDate": "2023-05-17T19:51:56+00:00",
        "queueTitle": "",
        "isPlanned": false,
        "mailTemplateId": "-1",
        "receiversSelect": '-1',
        "fromMailId": "-1",
        "type": "marketing",
        "isGroupSend": true,
        "mailGroupId": "-1",
        "targets": []
      }
    }
  },
  mounted() {
    this.getFromMails();
    this.getMailGroups();
    this.getMailTemplates();
  },
  methods: {
    getFromMails() {
      CollectionService.getCollection('frommail').then((res) => {
        if (res.success == true) {
          this.fromMails = res.fromMails;
        } else {
          console.log('error');
        }
      })
    },
    getMailGroups() {
      CollectionService.getCollection('mailgroup').then((res) => {
        if (res.success == true) {
          this.mailGroups = res.mailGroups;
        } else {
          console.log('error');
        }
      })
    },
    getMailTemplates() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { createdAt: -1 } };

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}&noCounts=1`
      CollectionService.getCollection('mailtemplate', query).then((res) => {
        if (res.success == true) {
          this.mailTemplates = res.mailTemplates;
        } else {
          console.log('error');
        }
      })
    },
    submit(e) {

      CollectionService.postWidthAuth('mailsend', this.payload).then((res) => {
        if (res.success == true) {

          this.notifyVue('bottom', 'right', 'success', res.bulkInsertResultCount + ' tane mail gönderme kuyruğuna eklendi.')
          setTimeout(() => {
            this.$router.push(`/admin/mailqueues`);
          }, 2000);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.error)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      });

    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: type
        })
    }

  }
}
</script>
<style></style>